import { request } from '~/agent';

export const listApplications = (params) => {
    return request.get(`applications`, params);
};

export const getApplication = (id, params) => {
    return request.get(`applications/${id}`, params);
};

export const deleteApplication = (id, params) => {
    return request.del(`applications/${id}`, params);
};